<template>
  <phone-modal
    v-if="showPhoneModal"
    @completed="onCompletedPhoneUpdate"
    @closed="showPhoneModal = false"
  />
  <template
    v-for="notificationType of notifications"
    :key="getKey(notificationType, fieldKey)"
  >
    <ToggleField
      v-if="!props.hideEnabled || !props.settings[notificationType]"
      :id="notificationType"
      :model-value="!!form[notificationType]"
      @update:model-value="onChange(notificationType, $event)"
    >
      {{ $t(props.translationScope + "." + notificationType) }}
    </ToggleField>
  </template>
</template>

<script lang="ts" setup>
import ToggleField from "@/components/form/toggle-field.vue";
import PhoneModal from "@/features/profile/phone-modal.vue";
import { NotificationSettings, NotificationType } from "@/types";
import { ref } from "vue";
import { api } from "@/api";
import { user } from '../user/store';
import { useTracker } from '@/utils/use-tracker';

const tracker = useTracker();

const props = defineProps<{
  translationScope: string;
  settings?: NotificationSettings;
  hideEnabled?: boolean;
  origin: string;
}>();

const notifications = [
  NotificationType.ReservationReminderEmail,
  NotificationType.ReservationReminderSms,
  NotificationType.Newsletter,
  // TODO: uncomment when notifications are implemented
  // NotificationType.FruitReviewNotification,
  // NotificationType.RecipesNotification,
  // NotificationType.OrderPickupReminder,
];

const form = ref({
  reservationReminderEmail: props.settings?.reservation_reminder_email ?? null,
  reservationReminderSms: user.value?.email ? props.settings?.reservation_reminder_sms : null,
  newsletter: props.settings?.newsletter ?? null,
});

const fieldKey = ref(0);
const showPhoneModal = ref(false);

const onChange = (type: NotificationType, value: boolean) => {
  if (NotificationType.ReservationReminderSms === type && value && !user.value?.phone) {
    showPhoneModal.value = true;
    form.value[type] = 0;
    fieldKey.value += 1;
    return;
  }

  return setNotification(type, value);
};

const getKey = (type: NotificationType, index: number) => {
  if (NotificationType.ReservationReminderSms != type) {
    return type;
  }
  return `${type}-${index}`;
};

const onCompletedPhoneUpdate = () => {
  setNotification(NotificationType.ReservationReminderSms, true);
  form.value[NotificationType.ReservationReminderSms] = 1;
  fieldKey.value += 1;
};

const setNotification = (type: NotificationType, value: boolean) => {
  tracker.trackNotificationSettingChange(type, value, props.origin as any);
  return api.profile.setNotification(type, value);
};
</script>
